import { useTranslation } from 'react-i18next';
import { tokens, Badge, BasePopover } from '@hotjar/hotsauce';
import styled from '@emotion/styled';

const InternalPopover = styled.div`
  white-space: pre-line;
  & strong {
    font-weight: 500;
  }
`;

export const ScaleTrialBadge = () => {
  const { t } = useTranslation();

  return (
    <BasePopover
      title={t('common:player.scale-trial-popover-title')}
      content={<InternalPopover>{t('common:player.scale-trial-popover-content')}</InternalPopover>}
      icon="info"
      withCloseButton={false}
      trigger="mouseenter focus"
    >
      <Badge kind="custom" size="s" color={tokens.BRAND_COLORS.ember_700}>
        {t('common:player.scale-trial')}
      </Badge>
    </BasePopover>
  );
};
